import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  submitGetLiveAccountsRequest,
  submitGetLiveAccountsSuccess,
  submitGetLiveAccountsFailure,
  SUBMIT_GET_LIVE_ACCOUNTS_REQUEST
} from "../actions/fetchLiveAccountsActions";
import { fetchLiveAccountsAgent } from "../../../services/accIqService";

function* submitGetLiveAccountsSaga(action) {
  try {
    const response = yield call(
      fetchLiveAccountsAgent
    );
    yield put(submitGetLiveAccountsSuccess(response || "No live accounts."));
  } catch (error) {
    yield put(submitGetLiveAccountsFailure(error.message));
  }
}

export function* watchGetLiveAccountsSaga() {
  yield takeLatest(SUBMIT_GET_LIVE_ACCOUNTS_REQUEST, submitGetLiveAccountsSaga);
}